<template>
  <div class="order-accident">
    <div class="container py-4">
      <h2 class="page-title mb-4">Перевірте дані та перейдіть до оформлення</h2>
      <div class="mb-4" v-if="!isPaid">
        <router-link
          :to="{ name: 'accidentSteps', query: orderId ? { orderId: orderId } : {} }"
          class="text-primary font-weight-bold"
          style="text-decoration: none;"
        >
          &lt; Повернутися до оформлення
        </router-link>
      </div>

      <div>
          <div class="order__block mb-4">
            <div class="p-3 bg-light text-center font-weight-bold border-bottom">Дані за договором</div>
            <div class="p-4 row">
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Програма</div>
                <div class="font-weight-500">Нещасний випадок</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Місце реєстрації</div>
                <div class="font-weight-500">{{ !searchInfo.countryId || searchInfo.countryId == 1 ? 'Україна' : 'Весь світ (за винятком України)' }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Термін дії</div>
                <div class="font-weight-500">{{ periodDisplay }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Початок дії договору</div>
                <div class="font-weight-500">{{ startDateDisplay }}</div>
              </div>
              <div class="col-md-6 mb-3" v-if="endDateDisplay">
                <div class="text-muted small">Дата закінчення дії договору</div>
                <div class="font-weight-500">{{ endDateDisplay }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Період дії страхового захисту</div>
                <div class="font-weight-500">{{ formatProtectionPeriod(searchInfo.protectionPeriod) }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Загальна страхова сума</div>
                <div class="font-weight-500">{{ sumDisplay }} грн</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Фактори що впливають на фінальну вартість</div>
                <div class="font-weight-500">{{ activeFactorsText }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Страхові ризики</div>
                <div class="font-weight-500">{{ coveredRisksText }}</div>
              </div>
            </div>

            <div class="p-3 bg-light text-center font-weight-bold border-bottom border-top">Страхувальник</div>
            <div class="p-4 row">
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Повне ім'я</div>
                <div class="font-weight-500">{{ payerFullName }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Дата народження</div>
                <div class="font-weight-500">{{ payer.dateBirth }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Телефон</div>
                <div class="font-weight-500">{{ payer.phone }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">Електронна пошта</div>
                <div class="font-weight-500">{{ payer.mail || payer.email }}</div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="text-muted small">ІПН</div>
                <div class="font-weight-500">{{ (payer.withoutIdentificationCode || !payer.identificationCode || payer.identificationCode === '0000000000') ? 'Відсутній' : payer.identificationCode }}</div>
              </div>
              <div class="col-md-6 mb-3" v-if="payerAddressDisplay">
                <div class="text-muted small">Прописка</div>
                <div class="font-weight-500">
                  {{ payerAddressDisplay }}
                </div>
              </div>
              <div class="col-md-6 mb-3" v-if="payer.documentation && (payer.documentation.number || payer.documentation.serial)">
                <div class="text-muted small">Документ</div>
                <div class="font-weight-500">{{ payerDocumentDisplay }}</div>
              </div>
            </div>

            <template v-if="hasInsuredPerson">
              <div class="p-3 bg-light text-center font-weight-bold border-bottom border-top">Застрахована особа</div>
              <div class="p-4 row">
                <div class="col-md-6 mb-3">
                  <div class="text-muted small">Повне ім'я</div>
                  <div class="font-weight-500">{{ insuredFullName }}</div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="text-muted small">Дата народження</div>
                  <div class="font-weight-500">{{ insured.dateBirth }}</div>
                </div>
                <div class="col-md-6 mb-3" v-if="insured.phone">
                  <div class="text-muted small">Телефон</div>
                  <div class="font-weight-500">{{ insured.phone }}</div>
                </div>
                <div class="col-md-6 mb-3" v-if="insured.mail || insured.email">
                  <div class="text-muted small">Електронна пошта</div>
                  <div class="font-weight-500">{{ insured.mail || insured.email }}</div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="text-muted small">ІПН</div>
                  <div class="font-weight-500">{{ (insured.withoutIdentificationCode || !insured.identificationCode || insured.identificationCode === '0000000000') ? 'Відсутній' : insured.identificationCode }}</div>
                </div>
                <div class="col-md-6 mb-3" v-if="insuredAddressDisplay">
                  <div class="text-muted small">Прописка</div>
                  <div class="font-weight-500">
                    {{ insuredAddressDisplay }}
                  </div>
                </div>
                <div class="col-md-6 mb-3" v-if="insured.documentation && (insured.documentation.number || insured.documentation.serial)">
                  <div class="text-muted small">Документ</div>
                  <div class="font-weight-500">{{ insuredDocumentDisplay }}</div>
                </div>
              </div>
            </template>
          </div>

          <div class="order__block p-4 mt-4">
            <PriceCard
              :finish-price="parseFloat(offerInfo.price || 0)"
              :old-price="0"
              :discount-amount="0"
              :earnings="parseFloat(offerInfo.earnings || offerInfo.commission || 0)"
              @bonusApplied="onBonusApplied"
              style="margin-bottom: 20px; margin-left: -24px; margin-right: -24px; margin-top: -24px; border-bottom: 1px solid #e1e8ed;"
            />


            <button class="btn btn-light w-100 py-2 mb-3" @click="goBack" :disabled="isOrderCreated" style="border: 1px solid #ddd;">
              Редагувати дані
            </button>

            <button
              v-if="orderId && isOrderCreated"
              class="btn btn-outline-primary w-100 py-2 mb-3"
              @click="openDraft"
            >
              Переглянути чернетку
            </button>

            <div class="mb-4">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="termsCheck" v-model="isAgreementAccepted" :disabled="isOrderCreated">
                <label class="custom-control-label text-muted small" for="termsCheck">
                  Згоден з обробкою персональних даних. Дані будуть передані в страхову компанію для формування поліса.
                </label>
              </div>
            </div>

            <button
              v-if="!isOrderCreated"
              class="btn btn-primary w-100 py-2 mb-3"
              :disabled="!isAgreementAccepted" :class="{ 'disabled-btn': !isAgreementAccepted }"
              @click.prevent="declareAndCheckout"
              v-loading="loading"
            >
              Заявити
            </button>

            <OtpSection
              v-if="isOrderCreated"
              ref="otpSection"
              :order-id="orderId"
              :requires-otp="true"
              :otp-flags="otpFlags"
              :is-otp-sending="otpSendingInProgress"
              :otp-sending-error="otpSendingError"
              :is-otp-checking="otpCheckingInProgress"
              :otp-checking-error="otpCheckingError"
              :hide-generate-button="true"
              @send-otp="onSendOtpRequest"
              @check-otp="onCheckOtpRequest"
              @clear-otp-check-error="onClearOtpCheckError"
              @verified="onOtpVerified"
              class="w-100 mt-3"
            />

            <div
              v-if="isOrderCreated && otpFlags.otpVerified"
              class="alert alert-success mt-3 d-flex align-items-center"
              role="alert"
            >
              <i class="el-icon-circle-check mr-2" style="font-size: 18px;"></i>
              <span>ОТП код успішно підтверджено</span>
            </div>

            <PaymentStatusPolling
              v-if="isOrderCreated"
              ref="paymentPolling"
              :order-id="orderId"
              :payments-data="payments"
              :payment-invoice-id="paymentInvoiceId"
              :is-paid="isPaid"
              :payment-check-result="paymentCheckResult"
              @fetch-payments="onFetchPaymentsRequest"
              @check-payment="onCheckPaymentRequest"
              @set-payment-invoice-id="paymentInvoiceId = $event"
              @set-payment-system-code="paymentSystemCode = $event"
              @processed="onPaymentProcessed"
              class="w-100 mt-3"
            />

            <button
              v-if="canShowPayButton"
              class="btn btn-primary w-100 py-2 mt-3"
              @click="onPayPolicy"
            >
              Сплатити поліс
            </button>

            <div v-if="showReceiptUpload" class="receipt-upload-wrapper mt-3">
              <ReceiptUpload
                :payments="payments"
                @uploaded="onReceiptUploaded"
                @removed="onReceiptRemoved"
              />
            </div>

            <button
              v-if="canShowConfirmButton"
              class="btn btn-success w-100 py-2 mt-3"
              :disabled="isConfirmDisabled"
              @click="onConfirmContract"
            >
              Оформити
            </button>
          </div>
      </div>
    </div>

    <ContractProcessingPopup
      ref="contractProcessingPopup"
    />

    <PolicySuccessPopup
      ref="policySuccessPopup"
      @closed="onPolicySuccessClosed"
    />

    <PaymentSystemSelector
      ref="paymentSystemSelector"
      :company-id="getCompanyId"
      program-name="accident"
      @selectPaymentSystem="onSelectPaymentSystem"
      @selectLegalInvoice="onSelectLegalInvoice"
    />

    <PaymentLinkPopup
      ref="paymentLinkPopup"
      :order-id="orderId"
      :price="getFinishPrice"
      :provider-data="selectedProviderData"
      @invoice-created="onInvoiceCreated"
      @closed="onPaymentLinkClosed"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import {
  OtpSection,
  PriceCard,
  PaymentStatusPolling,
  ContractProcessingPopup,
  PolicySuccessPopup,
  PaymentSystemSelector,
  PaymentLinkPopup,
  ReceiptUpload,
} from '@/shared/ui/insurance';
import {
  sendOtp,
  checkOtp,
  fetchOrder,
  checkPayment,
  createPaymentLink,
  confirmAccidentContract,
  takeAccidentContract,
} from '@/entities/insurance/api';
import { invoiceStatuses, invoiceTypes } from '@/entities/insurance/config';
import { orderAccident } from '@/api/orderAccident';
import { formatAccidentPeriod, normalizeAccidentPeriod } from '@/views/accident/data/accidentPeriods';
import { formatCoveredRisksCount } from '@/views/accident/data/accidentRisks';

export default {
  name: 'AccidentFinally',
  components: {
    OtpSection,
    PriceCard,
    PaymentStatusPolling,
    ContractProcessingPopup,
    PolicySuccessPopup,
    PaymentSystemSelector,
    PaymentLinkPopup,
    ReceiptUpload,
  },
  data() {
    return {
      loading: false,
      isAgreementAccepted: false,
      isOrderCreated: false,
      bonusSystemValue: 0,
      receiptLoaded: false,

      orderId: null,
      orderData: null,
      policyNumber: '',
      offerInfo: {},
      searchInfo: {},
      payer: {},
      insured: {},

      otpFlags: {
        otpSent: false,
        otpVerified: false,
      },
      otpSendingInProgress: false,
      otpSendingError: false,
      otpCheckingInProgress: false,
      otpCheckingError: false,

      payments: [],
      paymentInvoiceId: null,
      paymentSystemCode: null,
      paymentCheckResult: null,
      selectedProviderData: null,
      serverIsPaid: false,
      orderPrice: 0,
    };
  },
  computed: {
    ...mapGetters('currentUserModule', ['getUserInfo', 'getCurrentUserId', 'getParentId']),
    getCompanyId() {
      return this.offerInfo?.company?.id || this.offerInfo?.company_id || null;
    },
    getFinishPrice() {
      return parseFloat(this.offerInfo?.price || 0);
    },
    startDateDisplay() {
      const date = this.searchInfo?.startDate
        || this.offerInfo?.fromDate
        || this.orderData?.contract?.startedAt
        || (this.orderData?.started_at ? moment(this.orderData.started_at).format('DD.MM.YYYY') : '');
      return date || '';
    },
    endDateDisplay() {
      if (this.orderData?.contract?.finishedAt) {
        return this.orderData.contract.finishedAt;
      }
      if (this.orderData?.finished_at) {
        return moment(this.orderData.finished_at).format('DD.MM.YYYY');
      }
      if (this.searchInfo?.endDate) {
        return this.searchInfo.endDate;
      }
      const start = this.startDateDisplay;
      const period = this.searchInfo?.period || this.offerInfo?.period || this.offerInfo?.term;
      if (start && period) {
        const m = moment(start, 'DD.MM.YYYY', true);
        if (m.isValid()) {
          const days = normalizeAccidentPeriod(period);
          return m.add(days, 'days').subtract(1, 'day').format('DD.MM.YYYY');
        }
      }
      return '';
    },
    periodDisplay() {
      const p = this.searchInfo?.period || this.offerInfo?.period || this.offerInfo?.term || this.orderData?.accidentOffer?.period;
      return formatAccidentPeriod(p);
    },
    sumDisplay() {
      const s = this.searchInfo?.sum || this.searchInfo?.insuranceSum || this.offerInfo?.insuranceSum || this.offerInfo?.amount || this.orderData?.accidentOffer?.amount;
      if (!s) return '';
      return String(s).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    payerFullName() {
      return [this.payer?.surname, this.payer?.name, this.payer?.patronymic].filter(Boolean).join(' ');
    },
    insuredFullName() {
      return [this.insured?.surname, this.insured?.name, this.insured?.patronymic].filter(Boolean).join(' ');
    },
    payerAddressDisplay() {
      const p = this.payer || {};
      const cityName = typeof p.city === 'object' && p.city !== null
        ? (p.city.name_ua || p.city.name || '')
        : (p.city || '');
      const parts = [];
      if (cityName) parts.push(cityName);
      if (p.street) parts.push(`вул. ${p.street}`);
      if (p.house) parts.push(`буд. ${p.house}`);
      if (p.apartment) parts.push(`кв. ${p.apartment}`);
      return parts.join(', ');
    },
    insuredAddressDisplay() {
      const i = this.insured || {};
      const cityName = typeof i.city === 'object' && i.city !== null
        ? (i.city.name_ua || i.city.name || '')
        : (i.city || '');
      const parts = [];
      if (cityName) parts.push(cityName);
      if (i.street) parts.push(`вул. ${i.street}`);
      if (i.house) parts.push(`буд. ${i.house}`);
      if (i.apartment) parts.push(`кв. ${i.apartment}`);
      return parts.join(', ');
    },
    payerDocumentDisplay() {
      const doc = this.payer?.documentation;
      if (!doc) return '';
      const serial = doc.serial ? `${doc.serial} ` : '';
      const num = doc.number || '';
      const issue = doc.dateOfIssue ? ` (видано ${doc.dateOfIssue})` : '';
      return `${serial}${num}${issue}`.trim();
    },
    insuredDocumentDisplay() {
      const doc = this.insured?.documentation;
      if (!doc) return '';
      const serial = doc.serial ? `${doc.serial} ` : '';
      const num = doc.number || '';
      const issue = doc.dateOfIssue ? ` (видано ${doc.dateOfIssue})` : '';
      return `${serial}${num}${issue}`.trim();
    },
    hasInsuredPerson() {
      const i = this.insured;
      if (!i || (!i.surname && !i.name)) return false;
      const p = this.payer || {};
      if (i.identificationCode && p.identificationCode && i.identificationCode !== '0000000000' && i.identificationCode === p.identificationCode) {
        return false;
      }
      if (i.name === p.name && i.surname === p.surname && i.dateBirth === p.dateBirth) {
        return false;
      }
      return true;
    },
    activeFactorsText() {
      const s = this.searchInfo || {};
      const factors = [];
      if (s.warRisk || (Array.isArray(s.activeFactors) && s.activeFactors.includes('warRisk')) || s.activeFactor === 'warRisk') {
        factors.push('Воєнні ризики');
      }
      if ((s.sportType && s.sportType !== 'none' && s.sportType !== '140995') || s.sportGroup || (Array.isArray(s.activeFactors) && s.activeFactors.includes('sport')) || s.activeFactor === 'sport') {
        let sportText = 'Спорт';
        if (s.sportName) {
          sportText = `Спорт (${s.sportName})`;
        } else if (s.sportGroup) {
          sportText = `Спорт (Група ${s.sportGroup})`;
        } else if (['1409218', '1409219'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S0)';
        } else if (['1409221', '1409220'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S1)';
        } else if (['1409222', '1409223'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S2)';
        } else if (['1409224', '1409225'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група SE)';
        }
        factors.push(sportText);
      }
      if ((s.profession && s.profession !== 'none' && s.profession !== '1412260') || (Array.isArray(s.activeFactors) && s.activeFactors.includes('profession')) || s.activeFactor === 'profession') {
        factors.push('Професія');
      }
      if (factors.length === 0) {
        return 'Без підвищеного ризику';
      }
      return factors.join(', ');
    },
    coveredRisksText() {
      if (!this.searchInfo) return 'Базові (всі)';
      const count = formatCoveredRisksCount(this.searchInfo.accidentRisks || this.searchInfo.accident || this.searchInfo);
      return count ? `${count} обрано` : 'Базові (всі)';
    },
    getEarnings() {
      return parseFloat(this.offerInfo?.earnings || this.offerInfo?.commission || 0);
    },
    isOrganizationUser() {
      return !!this.getUserInfo?.organizationId;
    },
    getUserId() {
      return this.getParentId ?? this.getCurrentUserId;
    },
    isPaid() {
      if (this.serverIsPaid) return true;
      if (!this.payments?.length) return false;
      const basePrice = this.getFinishPrice || this.orderPrice;
      const sumPay = this.payments.reduce((sum, item) => {
        if (Number(item.invoice?.status_id) === invoiceStatuses.PAID) {
          return sum + parseFloat(item.invoice.amount);
        }
        return sum;
      }, 0);
      return sumPay > 0 && (basePrice <= 0 || sumPay >= basePrice);
    },
    canShowPayButton() {
      if (!this.isOrderCreated) return false;
      if (this.isPaid) return false;
      if (!this.otpFlags?.otpVerified) return false;
      return true;
    },
    showReceiptUpload() {
      if (this.isOrganizationUser) return false;
      if (!this.isOrderCreated) return false;
      if (!this.otpFlags?.otpVerified) return false;
      return this.payments?.some(p => p.invoice?.type_id === invoiceTypes.LEGAL_ENTITY_INSURANCE_PAYMENT);
    },
    canShowConfirmButton() {
      if (!this.isOrderCreated) return false;
      if (!this.otpFlags?.otpVerified) return false;
      return this.isPaid || this.receiptLoaded || this.showReceiptUpload || this.isOrganizationUser;
    },
    isConfirmDisabled() {
      if (!this.otpFlags?.otpVerified) return true;
      if (!this.isPaid && !this.receiptLoaded && !this.isOrganizationUser) return true;
      return false;
    },
  },
  async created() {
    this.$store.dispatch('initAccidentFullInfoOrder');
    this.$store.dispatch('initAccidentInfoOrder');
    this.$store.dispatch('initSearchAccidentParams');

    const orderData = this.$store.getters.GET_ACCIDENT_FULL_ORDER;
    const searchData = this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS;
    const offerData = this.$store.getters.GET_ACCIDENT_INFO_OFFER;
    const routeOrderId = this.$route.query.orderId;
    let orderId = routeOrderId || orderData?.orderId;

    if (!orderId && this.$route.query.invoice) {
      try {
        const invRes = await checkPayment(this.$route.query.invoice);
        const invOrder = invRes?.data?.invoice?.order || invRes?.data?.order;
        if (invOrder?.id) {
          orderId = invOrder.id;
        }
      } catch (e) {
        console.error('Error resolving order from invoice', e);
      }
    }

    if (orderData) {
      this.orderId = orderData.orderId || routeOrderId;
      this.offerInfo = orderData.offerInfo || offerData || {};
      this.searchInfo = orderData.searchInfo || searchData || {};
      this.payer = orderData.payer || {};
      this.insured = orderData.insured || {};

      if (orderData.isOrderCreated || [2, 5, 10].includes(Number(orderData.statusId)) || ['overdue', 'declared', 'concluded'].includes(orderData.status)) {
        this.isOrderCreated = true;
        this.isAgreementAccepted = true;
      }
      if (orderData.otpVerified) {
        this.otpFlags.otpSent = true;
        this.otpFlags.otpVerified = true;
      } else if (orderData.otpSent) {
        this.otpFlags.otpSent = true;
        this.otpFlags.otpVerified = false;
      }
      if (orderData.payments) {
        this.payments = orderData.payments;
        this.persistPaymentInvoiceId();
      }
    } else {
      if (searchData) this.searchInfo = { ...searchData };
      if (offerData) this.offerInfo = { ...offerData };
    }

    if (orderId) {
      await this.initOrderState(orderId);
    } else if (!orderData && !searchData) {
      this.$router.push({ name: 'accidentHome' });
    }
  },
  methods: {
    onBonusApplied(bonus) {
      this.bonusSystemValue = bonus || 0;
    },
    formatPeriod(period) {
      return formatAccidentPeriod(period);
    },
    formatProtectionPeriod(period) {
      if (!period || period === '24_7') return '24/7';
      if (period === 'study_work_hours' || period === 'working_hours') return 'Під час учбових занять / службових обов’язків';
      if (period === 'sport_hours') return 'Під час занять спортом/змагань';
      return period;
    },
    goBack() {
      if (this.isPaid) return;
      this.$router.push({ name: 'accidentSteps', query: this.orderId ? { orderId: this.orderId } : {} });
    },
    openOtpDirectionModal() {
      this.$nextTick(() => {
        if (this.$refs.otpSection && typeof this.$refs.otpSection.onOpenOtpDirection === 'function') {
          this.$refs.otpSection.onOpenOtpDirection();
        } else {
          setTimeout(() => {
            if (this.$refs.otpSection && typeof this.$refs.otpSection.onOpenOtpDirection === 'function') {
              this.$refs.otpSection.onOpenOtpDirection();
            }
          }, 300);
        }
      });
    },
    async initOrderState(orderId) {
      if (!orderId) return;
      this.orderId = orderId;
      try {
        const response = await fetchOrder(orderId, 12);
        const order = Array.isArray(response) ? response[0] : (response?.data || response);
        if (!order) return;
        this.orderData = order;

        const clientRequest = order.clientRequest || order.client_request || {};
        const clientPayer = clientRequest.payer || {};
        const clientInsured = clientRequest.insured || {};
        const clientSearch = clientRequest.searchInfo || {};
        const clientOffer = clientRequest.offerInfo || {};
        const insurant = order.insurant || {};
        const orderContract = order.contract || {};
        const accidentOffer = order.accidentOffer || {};

        this.payer = {
          ...clientPayer,
          ...this.payer,
        };
        if (!this.payer.name && insurant.name) this.payer.name = insurant.name;
        if (!this.payer.surname && insurant.surname) this.payer.surname = insurant.surname;
        if (!this.payer.patronymic && insurant.patronymic) this.payer.patronymic = insurant.patronymic;
        if (!this.payer.phone && insurant.phone) this.payer.phone = insurant.phone;
        if (!this.payer.mail && !this.payer.email && insurant.email) this.payer.mail = insurant.email;
        if (!this.payer.dateBirth && insurant.dateBirthAt) this.payer.dateBirth = insurant.dateBirthAt;
        if (!this.payer.identificationCode && insurant.documentation?.uin) this.payer.identificationCode = insurant.documentation.uin;
        if (!this.payer.city && insurant.city) this.payer.city = insurant.city;
        if (!this.payer.street && insurant.street) this.payer.street = insurant.street;
        if (!this.payer.house && insurant.house) this.payer.house = insurant.house;
        if (!this.payer.apartment && insurant.apartment) this.payer.apartment = insurant.apartment;
        if (!this.payer.documentation && insurant.documentation) this.payer.documentation = insurant.documentation;

        this.insured = {
          ...clientInsured,
          ...this.insured,
        };

        this.searchInfo = {
          ...clientSearch,
          ...this.searchInfo,
        };
        if (!this.searchInfo.startDate) {
          this.searchInfo.startDate = orderContract.startedAt || order.started_at || order.startedAt || accidentOffer.start_from || '';
        }
        if (!this.searchInfo.endDate) {
          this.searchInfo.endDate = orderContract.finishedAt || order.finished_at || order.finishedAt || '';
        }
        if (!this.searchInfo.period) {
          this.searchInfo.period = accidentOffer.period || this.offerInfo?.period || '';
        }
        if (!this.searchInfo.countryId) {
          this.searchInfo.countryId = accidentOffer.country_id || 1;
        }
        if (!this.searchInfo.sum) {
          this.searchInfo.sum = accidentOffer.amount || order.offer?.amount;
        }

        this.offerInfo = {
          ...clientOffer,
          ...this.offerInfo,
        };
        if (!this.offerInfo.price) {
          this.offerInfo.price = order.price || accidentOffer.price || 0;
          this.offerInfo.earnings = order.earnings || 0;
          this.offerInfo.company = order.companyInfo?.info || order.offer?.company || {};
        }

        this.serverIsPaid = Boolean(order.isPaid);
        this.orderPrice = parseFloat(order.price || 0);

        this.policyNumber = order.contract?.mtsbuCode
          || order.contract?.numberPolicy
          || order.mtsbuCode
          || '';

        const isDeclared = (
          [2, 5, 10].includes(Number(order.statusId || order.status_id)) ||
          ['overdue', 'declared', 'concluded'].includes(order.status) ||
          !!order.external_id ||
          !!order.externalId
        );

        if (isDeclared) {
          this.isOrderCreated = true;
          this.isAgreementAccepted = true;
        }

        const otpHist = Array.isArray(order.otpHistory) ? order.otpHistory[0] : order.otpHistory;
        const isOtpVerified = !!(
          otpHist?.date_otp_entered ||
          otpHist?.date_offer_agreed ||
          otpHist?.date_order_concluded ||
          otpHist?.isOtpVerified ||
          Number(order.statusId || order.status_id) === 10
        );

        const isOtpSent = isOtpVerified || !!(
          otpHist?.date_otp_sent ||
          otpHist?.send_status === 'sent'
        );

        this.otpFlags = {
          otpSent: isOtpSent,
          otpVerified: isOtpVerified,
        };

        if (this.isOrderCreated && !isOtpSent && !isOtpVerified) {
          this.openOtpDirectionModal();
        }

        this.payments = order.payments || order.paymentInvoices || order.data?.payments || [];
        this.persistPaymentInvoiceId();
        const hasReceipt = this.payments?.some(
          p => p.invoice?.type_id === invoiceTypes.LEGAL_ENTITY_INSURANCE_PAYMENT && p.invoice?.receipt
        );
        if (hasReceipt) {
          this.receiptLoaded = true;
        }

        const hasPaidInvoice = this.payments?.some(
          p => Number(p.invoice?.status_id) === invoiceStatuses.PAID
        );
        if (hasPaidInvoice) {
          this.serverIsPaid = true;
        }

        const currentStored = this.$store.getters.GET_ACCIDENT_FULL_ORDER || {};
        this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
          ...currentStored,
          orderId: this.orderId,
          price: this.offerInfo?.price || order.price,
          searchInfo: this.searchInfo,
          offerInfo: this.offerInfo,
          payer: this.payer,
          insured: this.insured,
          statusId: order.statusId || order.status_id,
          status: order.status,
          isOrderCreated: this.isOrderCreated,
          otpSent: isOtpSent,
          otpVerified: isOtpVerified,
          payments: this.payments,
        });
      } catch (e) {
        console.error('Error in initOrderState', e);
      }
    },
    async declareAndCheckout() {
      if (!this.isAgreementAccepted) return;

      this.loading = true;
      try {
        const response = await orderAccident(
          this.offerInfo,
          this.searchInfo,
          this.payer,
          this.insured,
          this.orderId,
          { statusId: 5 }, // 5 = declared (Order::STATUS_ID['declared'])
          this.bonusSystemValue
        );

        const isErrorInData = response?.data?.data && response.data.data[0]?.status === 'error';
        if (response.data && response.data.status === 'success' && !isErrorInData) {
            const orderRes = response.data?.data?.[0] || response.data;
            if (orderRes?.id) {
              this.orderId = orderRes.id;
            }
            this.policyNumber = orderRes?.mtsbuCode
              || orderRes?.contract?.mtsbuCode
              || '';
            if (this.orderId && this.$route.query.orderId !== this.orderId) {
              this.$router.replace({ query: { ...this.$route.query, orderId: this.orderId } });
            }

            this.isOrderCreated = true;
            this.otpFlags.otpSent = false;
            this.otpFlags.otpVerified = false;

            const currentStored = this.$store.getters.GET_ACCIDENT_FULL_ORDER || {};
            this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
              ...currentStored,
              orderId: this.orderId,
              statusId: 5,
              status: 'declared',
              isOrderCreated: true,
              otpSent: false,
              otpVerified: false,
            });

            this.showSuccess('Замовлення успішно заявлено!');
            this.onFetchPaymentsRequest(this.orderId);
            this.openOtpDirectionModal();
        } else {
            const rawErr = response?.data?.data && response.data.data[0]?.message
                ? response.data.data[0].message
                : (response.data.message || 'Помилка при заявленні договору');
            this.showError(this.formatErrorMessage(rawErr));
        }
      } catch (e) {
        console.error('Declare order error', e);
        const rawErr = e?.response?.data?.data && e.response.data.data[0]?.message
          ? e.response.data.data[0].message
          : (e?.response?.data?.message || 'Помилка при заявленні договору');
        this.showError(this.formatErrorMessage(rawErr));
      } finally {
        this.loading = false;
      }
    },
    showSuccess(message) {
      if (this.$message && typeof this.$message.success === 'function') {
        this.$message.success(message);
      } else if (this.$toast && typeof this.$toast.success === 'function') {
        this.$toast.success(message);
      }
    },
    showError(message) {
      if (this.$message && typeof this.$message.error === 'function') {
        this.$message.error(message);
      } else if (this.$toast && typeof this.$toast.error === 'function') {
        this.$toast.error(message);
      }
    },
    formatErrorMessage(error) {
      if (!error) return 'Помилка при заявленні договору';
      if (typeof error === 'string') {
        try {
          const parsed = JSON.parse(error);
          if (Array.isArray(parsed)) {
            return parsed.map(item => item.text || item.message || JSON.stringify(item)).join('; ');
          }
          if (parsed && typeof parsed === 'object') {
            return parsed.message || parsed.error || error;
          }
        } catch (_) {
          return error;
        }
      }
      if (Array.isArray(error)) {
        return error.map(item => item.text || item.message || JSON.stringify(item)).join('; ');
      }
      return error.message || String(error);
    },
    async onSendOtpRequest({ type, commissionPaidBy }) {
      this.otpSendingInProgress = true;
      this.otpSendingError = false;
      try {
        const response = await sendOtp(this.orderId, type, commissionPaidBy);
        if (response?.data?.message === 'OK' && response?.data?.data !== 'ERROR') {
          this.otpFlags.otpSent = true;
          this.showSuccess('ОТП код успішно відправлено');
          const currentStored = this.$store.getters.GET_ACCIDENT_FULL_ORDER || {};
          this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
            ...currentStored,
            otpSent: true,
          });
        } else {
          this.otpSendingError = true;
          const errText = (response?.data?.data === 'ERROR' && response?.data?.message)
            ? response.data.message
            : 'Виникла помилка при відправленні ОТП коду';
          this.showError(errText);
        }
      } catch (e) {
        this.otpSendingError = true;
        this.showError(e?.response?.data?.message || 'Помилка при відправленні ОТП коду');
      } finally {
        this.otpSendingInProgress = false;
      }
    },
    async onCheckOtpRequest({ otp, additionalOtps }) {
      this.otpCheckingInProgress = true;
      this.otpCheckingError = false;
      try {
        await checkOtp(this.orderId, otp, additionalOtps);
        this.onOtpVerified();
        this.showSuccess('Код успішно підтверджено!');
      } catch (e) {
        this.otpCheckingError = true;
      } finally {
        this.otpCheckingInProgress = false;
      }
    },
    onClearOtpCheckError() {
      this.otpCheckingError = false;
    },
    onOtpVerified() {
      this.otpFlags.otpVerified = true;
      this.otpFlags.otpSent = true;
      const currentStored = this.$store.getters.GET_ACCIDENT_FULL_ORDER || {};
      this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
        ...currentStored,
        otpSent: true,
        otpVerified: true,
      });
      this.onFetchPaymentsRequest(this.orderId);
    },
    onPayPolicy() {
      this.$refs.paymentSystemSelector.open({
        price: this.getFinishPrice,
        earnings: this.getEarnings,
        orderData: { orderId: this.orderId },
      });
    },
    onSelectPaymentSystem({ providerData }) {
      this.selectedProviderData = providerData;
      this.paymentSystemCode = providerData?.code || null;
      this.$nextTick(() => {
        this.$refs.paymentLinkPopup.open(this.orderId, this.getFinishPrice, providerData);
      });
      this.$refs.paymentPolling?.startPolling();
    },
    async onSelectLegalInvoice() {
      const loading = this.$loading({
        lock: true,
        text: 'Формування рахунку-фактури...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      try {
        if (!this.getUserInfo?.organizationId) {
          await createPaymentLink({
            orderId: this.orderId,
            amount: this.getFinishPrice,
            invoiceType: 'legal-entity-insurance',
          });
        }

        await this.onFetchPaymentsRequest(this.orderId);
        this.persistPaymentInvoiceId();
        this.paymentSystemCode = 'legal-entity';

        const invoiceLegalData = {
          company: this.offerInfo?.company?.name || 'INGO',
          code: this.payer?.identificationCode || '',
          price: this.getFinishPrice,
          policyNumber: this.policyNumber || '',
          mtsbuCode: this.policyNumber || '',
        };

        const params = new URLSearchParams(invoiceLegalData).toString();
        const url = `/api/orders/show-invoice-legal/${this.getUserId}/${this.orderId}?${params}`;
        window.open(url, '_blank');

        this.$refs.paymentPolling?.startPolling();
      } catch (e) {
        console.error('Error creating legal invoice', e);
        this.showError('Помилка при формуванні рахунку-фактури');
      } finally {
        loading.close();
      }
    },
    onPaymentProcessed() {
      this.$refs.paymentLinkPopup?.close();
      this.serverIsPaid = true;
      this.showSuccess('Оплата успішно отримана!');
    },
    onPaymentLinkClosed() {
      this.selectedProviderData = null;
    },
    async onInvoiceCreated() {
      await this.onFetchPaymentsRequest(this.orderId);
      this.persistPaymentInvoiceId();
    },
    persistPaymentInvoiceId() {
      const invoice = this.payments?.find(p => p.invoice?.type_id === invoiceTypes.INSURANCE_PAYMENT);
      if (invoice?.invoice?.id) {
        this.paymentInvoiceId = invoice.invoice.id;
      }
    },
    onReceiptUploaded() {
      this.receiptLoaded = true;
      this.onFetchPaymentsRequest(this.orderId);
    },
    onReceiptRemoved() {
      this.receiptLoaded = false;
    },
    async onFetchPaymentsRequest(orderId) {
      const id = orderId || this.orderId;
      if (!id) return;
      try {
        const response = await fetchOrder(id, 12);
        const orderData = Array.isArray(response) ? response[0] : (response?.data || response);
        this.payments = orderData?.payments || orderData?.paymentInvoices || orderData?.data?.payments || [];
        this.persistPaymentInvoiceId();
        const hasReceipt = this.payments?.some(
          p => p.invoice?.type_id === invoiceTypes.LEGAL_ENTITY_INSURANCE_PAYMENT && p.invoice?.receipt
        );
        if (hasReceipt) {
          this.receiptLoaded = true;
        }

        const hasPaidInvoice = this.payments?.some(
          p => Number(p.invoice?.status_id) === invoiceStatuses.PAID
        );
        if (orderData?.isPaid || hasPaidInvoice) {
          this.serverIsPaid = true;
        }
        if (orderData?.price) {
          this.orderPrice = parseFloat(orderData.price || 0);
          if (!this.offerInfo?.price) {
            if (!this.offerInfo) this.offerInfo = {};
            this.$set(this.offerInfo, 'price', orderData.price);
          }
        }

        const currentStored = this.$store.getters.GET_ACCIDENT_FULL_ORDER || {};
        this.$store.commit('SET_ACCIDENT_FULL_ORDER', {
          ...currentStored,
          payments: this.payments,
        });
      } catch (e) {
        console.error('Fetch payments error', e);
      }
    },
    async onCheckPaymentRequest(invoiceId) {
      try {
        const result = await checkPayment(invoiceId);
        this.paymentCheckResult = {
          invoiceId,
          statusId: result?.data?.invoice?.status_id,
          message: result?.message,
        };
      } catch (e) {
        this.paymentCheckResult = {
          invoiceId,
          error: e?.response?.data?.message || 'Помилка перевірки статусу оплати',
        };
      }
    },
    async onConfirmContract() {
      const fullOrder = this.$store.getters.GET_ACCIDENT_FULL_ORDER;
      const data = {
        orderId: this.orderId,
        bonusSystemValue: this.bonusSystemValue,
        usedPaymentSystem: this.isPaid,
        prolongOrderId: fullOrder?.prolongOrderId || this.offerInfo?.prolongOrderId || null,
      };

      this.$refs.contractProcessingPopup?.open();

      try {
        const result = await confirmAccidentContract(data);

        this.$refs.contractProcessingPopup?.close();

        if (result?.status === 'success') {
          const contractId = result?.data?.[0]?.contractId || result?.contractId;
          const policyCode = result?.data?.[0]?.agreementNum || '';
          const companyLogo = this.offerInfo?.company?.logo || '';
          const companyName = this.offerInfo?.company?.name || 'INGO';
          let policyLink = result?.policyLink || result?.data?.[0]?.policyLink || '';

          if (contractId) {
            try {
              const takeRes = await takeAccidentContract(contractId);
              const downloadedUrl = takeRes?.data?.[0]?.contract || takeRes?.contract;
              if (downloadedUrl) {
                policyLink = downloadedUrl;
              }
            } catch (e) {
              console.error('Error fetching accident policy PDF', e);
            }
          }

          this.$refs.policySuccessPopup?.open(policyLink, companyLogo, companyName, policyCode);
          return;
        }

        const errText = result?.message || (result?.data && result.data[0]?.message) || 'Сталася помилка при оформленні договору';
        this.showError(this.formatErrorMessage(errText));
      } catch (e) {
        this.$refs.contractProcessingPopup?.close();
        const errText = e?.response?.data?.data?.orderId?.[0]
          || e?.response?.data?.message
          || 'Сталася помилка при оформленні договору';
        this.showError(this.formatErrorMessage(errText));
      }
    },
    openDraft() {
      window.open(`/api/orders/draft/${this.getUserId}/${this.orderId}`, '_blank');
    },
    onPolicySuccessClosed() {
      this.$router.push({ name: 'history' });
    },
  },
};
</script>

<style scoped>
.order-accident {
  background: #f7f9fa;
  min-height: 100vh;
}
.page-title {
  font-size: 24px;
  font-weight: bold;
}
.order__block {
  background: #fff;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  overflow: hidden;
}
.font-weight-500 {
  font-weight: 500;
}
.disabled-btn {
  background-color: #a0c4ff !important;
  border-color: #a0c4ff !important;
  cursor: not-allowed;
}
.receipt-upload-wrapper {
  display: flex;
  justify-content: center;
}
.receipt-upload-wrapper ::v-deep .receipt-upload {
  width: 100%;
}
</style>
